import { motion, useReducedMotion } from "framer-motion";
import { LunarMark } from "./Logo";
import { Reveal, Chapter } from "./Reveal";

const SOCIAL_BUBBLES = [
    {
        label: "A new best mate",
        desktop: "lg:left-[17%] lg:top-[18%]",
        width: "lg:w-[150px]",
        tone: "border-[#D8D5CB] bg-[#F2F0EA] text-[#2C3618]",
        rotate: -3,
    },
    {
        label: "A padel partner",
        desktop: "lg:left-[76%] lg:top-[14%]",
        width: "lg:w-[150px]",
        tone: "border-[#C9D1B7] bg-[#EEF1E5] text-[#2C3618]",
        rotate: 2,
    },
    {
        label: "A running buddy",
        desktop: "lg:left-[10%] lg:top-[34%]",
        width: "lg:w-[150px]",
        tone: "border-[#D8D5CB] bg-[#F9F8F4] text-[#2C3618]",
        rotate: 2,
    },
    {
        label: "A gym partner",
        desktop: "lg:left-[86%] lg:top-[32%]",
        width: "lg:w-[140px]",
        tone: "border-[#D8D5CB] bg-[#EBE8DF] text-[#2C3618]",
        rotate: -2,
    },
    {
        label: "Someone new to town",
        desktop: "lg:left-[26%] lg:top-[44%]",
        width: "lg:w-[170px]",
        tone: "border-[#C9D1B7] bg-[#F2F0EA] text-[#2C3618]",
        rotate: 1,
    },
    {
        label: "Someone to travel with",
        desktop: "lg:left-[70%] lg:top-[42%]",
        width: "lg:w-[170px]",
        tone: "border-[#D8D5CB] bg-[#F9F8F4] text-[#2C3618]",
        rotate: -1,
    },
    {
        label: "Someone to go to gigs with",
        desktop: "lg:left-[11%] lg:top-[58%]",
        width: "lg:w-[190px]",
        tone: "border-[#D8D5CB] bg-[#EBE8DF] text-[#2C3618]",
        rotate: -2,
    },
    {
        label: "A festival crew",
        desktop: "lg:left-[84%] lg:top-[56%]",
        width: "lg:w-[150px]",
        tone: "border-[#C9D1B7] bg-[#EEF1E5] text-[#2C3618]",
        rotate: 3,
    },
    {
        label: "Someone who loves dogs",
        desktop: "lg:left-[25%] lg:top-[73%]",
        width: "lg:w-[170px]",
        tone: "border-[#D8D5CB] bg-[#F9F8F4] text-[#2C3618]",
        rotate: -1,
    },
    {
        label: "A new five-a-side team",
        desktop: "lg:left-[70%] lg:top-[75%]",
        width: "lg:w-[180px]",
        tone: "border-[#D8D5CB] bg-[#F2F0EA] text-[#2C3618]",
        rotate: 2,
    },
    {
        label: "Someone to grab a coffee with",
        desktop: "lg:left-[16%] lg:top-[84%]",
        width: "lg:w-[200px]",
        tone: "border-[#C9D1B7] bg-[#EEF1E5] text-[#2C3618]",
        rotate: 1,
    },
    {
        label: "Someone who shares your weird hobby",
        desktop: "lg:left-[82%] lg:top-[89%]",
        width: "lg:w-[220px]",
        tone: "border-[#D8D5CB] bg-[#F9F8F4] text-[#2C3618]",
        rotate: -3,
    },
    {
        label: "A neighbour you actually like 😂",
        desktop: "lg:left-[39%] lg:top-[88%]",
        width: "lg:w-[190px]",
        tone: "border-[#D8D5CB] bg-[#EBE8DF] text-[#2C3618]",
        rotate: 2,
    },
    {
        label: "Someone completely unexpected",
        desktop: "lg:left-[59%] lg:top-[87%]",
        width: "lg:w-[190px]",
        tone: "border-[#C9D1B7] bg-[#F2F0EA] text-[#2C3618]",
        rotate: -1,
    },
    {
        label: "Someone worth meeting 🌿",
        desktop: "lg:left-[50%] lg:top-[7%]",
        width: "lg:w-[180px]",
        tone: "border-[#2C3618] bg-[#2C3618] text-[#F9F8F4]",
        rotate: 1,
    },
];

const NETWORK_BUBBLES = [
    {
        label: "Your next client",
        desktop: "lg:left-[17%] lg:top-[18%]",
        width: "lg:w-[150px]",
        tone: "border-[#D8D5CB] bg-[#F2F0EA] text-[#2C3618]",
        rotate: -3,
    },
    {
        label: "A potential investor",
        desktop: "lg:left-[76%] lg:top-[14%]",
        width: "lg:w-[160px]",
        tone: "border-[#C9D1B7] bg-[#EEF1E5] text-[#2C3618]",
        rotate: 2,
    },
    {
        label: "A future business partner",
        desktop: "lg:left-[10%] lg:top-[34%]",
        width: "lg:w-[180px]",
        tone: "border-[#D8D5CB] bg-[#F9F8F4] text-[#2C3618]",
        rotate: 2,
    },
    {
        label: "Someone looking for what you do",
        desktop: "lg:left-[84%] lg:top-[32%]",
        width: "lg:w-[210px]",
        tone: "border-[#D8D5CB] bg-[#EBE8DF] text-[#2C3618]",
        rotate: -2,
    },
    {
        label: "A potential supplier",
        desktop: "lg:left-[26%] lg:top-[44%]",
        width: "lg:w-[160px]",
        tone: "border-[#C9D1B7] bg-[#F2F0EA] text-[#2C3618]",
        rotate: 1,
    },
    {
        label: "Your next hire",
        desktop: "lg:left-[72%] lg:top-[43%]",
        width: "lg:w-[150px]",
        tone: "border-[#D8D5CB] bg-[#F9F8F4] text-[#2C3618]",
        rotate: -1,
    },
    {
        label: "An industry expert",
        desktop: "lg:left-[11%] lg:top-[58%]",
        width: "lg:w-[160px]",
        tone: "border-[#D8D5CB] bg-[#EBE8DF] text-[#2C3618]",
        rotate: -2,
    },
    {
        label: "Someone to collaborate with",
        desktop: "lg:left-[83%] lg:top-[56%]",
        width: "lg:w-[190px]",
        tone: "border-[#C9D1B7] bg-[#EEF1E5] text-[#2C3618]",
        rotate: 3,
    },
    {
        label: "A new customer",
        desktop: "lg:left-[24%] lg:top-[73%]",
        width: "lg:w-[150px]",
        tone: "border-[#D8D5CB] bg-[#F9F8F4] text-[#2C3618]",
        rotate: -1,
    },
    {
        label: "Someone with the introduction you need",
        desktop: "lg:left-[72%] lg:top-[74%]",
        width: "lg:w-[220px]",
        tone: "border-[#D8D5CB] bg-[#F2F0EA] text-[#2C3618]",
        rotate: 2,
    },
    {
        label: "A future mentor",
        desktop: "lg:left-[15%] lg:top-[85%]",
        width: "lg:w-[150px]",
        tone: "border-[#C9D1B7] bg-[#EEF1E5] text-[#2C3618]",
        rotate: 1,
    },
    {
        label: "Someone new to your industry",
        desktop: "lg:left-[80%] lg:top-[88%]",
        width: "lg:w-[200px]",
        tone: "border-[#D8D5CB] bg-[#F9F8F4] text-[#2C3618]",
        rotate: -3,
    },
    {
        label: "Your next big opportunity",
        desktop: "lg:left-[45%] lg:top-[87%]",
        width: "lg:w-[190px]",
        tone: "border-[#D8D5CB] bg-[#EBE8DF] text-[#2C3618]",
        rotate: 2,
    },
    {
        label: "Someone worth knowing 🌿",
        desktop: "lg:left-[50%] lg:top-[7%]",
        width: "lg:w-[180px]",
        tone: "border-[#2C3618] bg-[#2C3618] text-[#F9F8F4]",
        rotate: 1,
    },
];

const DOT_COLORS = [
    "rgb(44, 54, 24)",
    "rgb(74, 93, 35)",
    "rgb(137, 155, 106)",
    "rgb(194, 192, 184)",
    "rgb(213, 216, 203)",
];

const seededRandom = (seed) => {
    let value = seed;
    return () => {
        value = (value * 1664525 + 1013904223) % 4294967296;
        return value / 4294967296;
    };
};

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
const randomDot = seededRandom(240824);

const PEOPLE_DOTS = Array.from({ length: 112 }, (_, i) => {
    const angle = randomDot() * Math.PI * 2;
    const radius = Math.pow(randomDot(), 1.28);
    const left = clamp(50 + Math.cos(angle) * radius * 48 + (randomDot() - 0.5) * 9, 3, 97);
    const top = clamp(50 + Math.sin(angle) * radius * 44 + (randomDot() - 0.5) * 9, 5, 95);
    const sizeRoll = randomDot();
    const size =
        sizeRoll < 0.44
            ? 3 + randomDot() * 3
            : sizeRoll < 0.86
              ? 6 + randomDot() * 5
              : 11 + randomDot() * 5;
    const movementRoll = randomDot();

    return {
        left: `${left.toFixed(2)}%`,
        top: `${top.toFixed(2)}%`,
        size: Math.round(size),
        color: DOT_COLORS[Math.floor(randomDot() * DOT_COLORS.length)],
        opacity: Number((0.08 + randomDot() * 0.34).toFixed(2)),
        movement: movementRoll < 0.14 ? "pulse" : movementRoll < 0.31 ? "drift" : null,
        duration: 5.5 + randomDot() * 5.5,
        delay: randomDot() * 4,
    };
});

const PeopleCloudSection = ({
    sectionTestId,
    chapterIndex,
    chapterLabel = "Who might you find?",
    chapterTestId,
    heading,
    headingTestId,
    subtitle,
    subtitleTestId,
    bubblesContainerTestId,
    ambientDotsTestId,
    ambientDotTestIdPrefix,
    centerIconTestId,
    bubbleTestIdPrefix,
    bubbles,
}) => {
    const reduceMotion = useReducedMotion();

    return (
        <section className="mx-auto max-w-6xl px-6 py-24 sm:py-32" data-testid={sectionTestId}>
            <Reveal className="max-w-2xl">
                <div data-testid={chapterTestId}>
                    <Chapter index={chapterIndex} label={chapterLabel} />
                </div>
                <h2
                    data-testid={headingTestId}
                    className="font-display mt-5 text-4xl font-medium leading-[1.1] tracking-tight text-[#1D201A] sm:text-5xl"
                >
                    {heading}
                </h2>
                {subtitle && (
                    <p
                        data-testid={subtitleTestId}
                        className="mt-5 max-w-xl text-base leading-relaxed text-[#5C5F58] sm:text-lg"
                    >
                        {subtitle}
                    </p>
                )}
            </Reveal>

            <Reveal delay={0.12}>
                <div
                    data-testid={bubblesContainerTestId}
                    aria-label="Examples of people you might find through Lunar"
                    className="relative mx-auto mt-14 flex max-w-4xl flex-wrap items-center justify-center gap-4 sm:gap-5 lg:mt-16 lg:block lg:h-[680px] lg:max-w-5xl"
                >
                    <div
                        data-testid={ambientDotsTestId}
                        aria-hidden="true"
                        className="pointer-events-none absolute inset-0 z-0"
                    >
                        {PEOPLE_DOTS.map((dot, i) => {
                            const style = {
                                left: dot.left,
                                top: dot.top,
                                width: dot.size,
                                height: dot.size,
                                backgroundColor: dot.color,
                                opacity: dot.opacity,
                            };
                            const peakOpacity = Math.min(dot.opacity * 1.35, 0.5);
                            const animate =
                                dot.movement === "pulse"
                                    ? { opacity: [dot.opacity * 0.75, peakOpacity, dot.opacity * 0.75], scale: [1, 1.18, 1] }
                                    : { x: [0, 3, 0], y: [0, -4, 0], opacity: [dot.opacity * 0.8, peakOpacity, dot.opacity * 0.8] };

                            return dot.movement && !reduceMotion ? (
                                <motion.span
                                    key={i}
                                    data-testid={`${ambientDotTestIdPrefix}${i + 1}`}
                                    style={style}
                                    animate={animate}
                                    transition={{
                                        duration: dot.duration,
                                        repeat: Infinity,
                                        ease: "easeInOut",
                                        delay: dot.delay,
                                    }}
                                    className="absolute rounded-full"
                                />
                            ) : (
                                <span
                                    key={i}
                                    data-testid={`${ambientDotTestIdPrefix}${i + 1}`}
                                    style={style}
                                    className="absolute rounded-full"
                                />
                            );
                        })}
                    </div>

                    <div
                        style={{ order: Math.floor(bubbles.length / 2) + 1 }}
                        className="relative z-10 mx-4 my-5 flex basis-full justify-center lg:absolute lg:left-1/2 lg:top-1/2 lg:m-0 lg:block lg:basis-auto lg:-translate-x-1/2 lg:-translate-y-1/2"
                    >
                        <div className="relative h-28 w-28 sm:h-32 sm:w-32">
                            <motion.div
                                aria-hidden="true"
                                animate={{ opacity: [0.45, 0.2, 0.45], scale: [1, 1.08, 1] }}
                                transition={{ duration: 4.8, repeat: Infinity, ease: "easeInOut" }}
                                className="absolute -inset-4 rounded-full bg-[#D5D8CB]"
                            />
                            <div className="relative flex h-full w-full items-center justify-center rounded-full border border-[#C2C0B8] bg-[#F0EFEB]">
                                <LunarMark size={66} data-testid={centerIconTestId} />
                            </div>
                        </div>
                    </div>

                    {bubbles.map((bubble, i) => (
                        <div
                            key={bubble.label}
                            data-testid={`${bubbleTestIdPrefix}${i + 1}`}
                            style={{ order: i < Math.floor(bubbles.length / 2) ? i + 1 : i + 2 }}
                            className={`relative z-20 lg:absolute lg:-translate-x-1/2 ${bubble.desktop}`}
                        >
                            <motion.div
                                initial={{ opacity: 0, y: 18, rotate: bubble.rotate }}
                                whileInView={{ opacity: 1, y: 0, rotate: bubble.rotate }}
                                viewport={{ once: true, margin: "-80px" }}
                                transition={{ duration: 0.65, delay: i * 0.045, ease: [0.22, 1, 0.36, 1] }}
                            >
                                <motion.div
                                    animate={{ y: [0, -4, 0], rotate: [bubble.rotate, bubble.rotate + 0.5, bubble.rotate] }}
                                    whileHover={{ scale: 1.04 }}
                                    transition={{
                                        duration: 4.2 + (i % 4) * 0.35,
                                        repeat: Infinity,
                                        ease: "easeInOut",
                                        delay: i * 0.12,
                                    }}
                                    className={`flex min-w-[108px] max-w-[160px] items-center justify-center rounded-full border px-4 py-2.5 text-center text-[11px] font-medium leading-snug sm:max-w-[220px] sm:px-5 sm:py-3 sm:text-sm lg:max-w-none ${bubble.width} ${bubble.tone}`}
                                >
                                    {bubble.label}
                                </motion.div>
                            </motion.div>
                        </div>
                    ))}
                </div>
            </Reveal>
        </section>
    );
};

export const WhoMightYouFind = () => (
    <PeopleCloudSection
        sectionTestId="who-might-you-find-section"
        chapterIndex="03"
        chapterLabel="Who might you find?"
        chapterTestId="who-might-you-find-chapter"
        heading="Lunar helps you find people around you."
        headingTestId="who-might-you-find-heading"
        bubblesContainerTestId="who-might-you-find-bubbles-container"
        ambientDotsTestId="who-might-you-find-ambient-dots"
        ambientDotTestIdPrefix="who-might-you-find-ambient-dot-"
        centerIconTestId="who-might-you-find-center-icon"
        bubbleTestIdPrefix="who-might-you-find-bubble-"
        bubbles={SOCIAL_BUBBLES}
    />
);

export const NetworkingWhoMightYouFind = () => (
    <PeopleCloudSection
        sectionTestId="network-who-might-you-find-section"
        chapterIndex="02"
        chapterLabel="Who might you find?"
        chapterTestId="network-who-might-you-find-chapter"
        heading="Who might you find?"
        headingTestId="network-who-might-you-find-heading"
        subtitle="Lunar helps you find the right people around you professionally."
        subtitleTestId="network-who-might-you-find-subtitle"
        bubblesContainerTestId="network-who-might-you-find-bubbles-container"
        ambientDotsTestId="network-who-might-you-find-ambient-dots"
        ambientDotTestIdPrefix="network-who-might-you-find-ambient-dot-"
        centerIconTestId="network-who-might-you-find-center-icon"
        bubbleTestIdPrefix="network-who-might-you-find-bubble-"
        bubbles={NETWORK_BUBBLES}
    />
);
